import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import Loader from 'react-loader'
import ReactTooltip from 'react-tooltip'
import config from '../../config'
import container from '../../helpers/container'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import {
  ContainerDivs,
  Chart,
  Link,
  LinkIcon,
  Tweeter,
  // FlaggedFund,
  Grade,
  // SocialButtons
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundManager.css'


@CSSModules(Styles, {allowMultiple:true})
class UssifLogo extends Component {
  render() {
    const ussifLogo = require( '../../../static/images/ussif-icon.png' )
    return (
      <div
        styleName='ussif-logo-for-manager-name'
        data-multiline
        data-effect={'solid'}
        data-tip="<div style='max-width:150px;'>Has US-SIF member funds</div>"
        data-html
        data-place='right'
        data-for='ussif-logo-for-manager-name'
      >
        <img src={ussifLogo} alt='Asset manager has US-SIF member funds'/>
        member funds
        <ReactTooltip id='ussif-logo-for-manager-name'/>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class SriLogo extends Component {
  render() {
    return (
      <div
        styleName='sri-logo-for-manager-name'
        data-multiline
        data-effect={'solid'}
        data-tip="<div style='max-width:150px;'>At least 50% of assets invested in funds with a sustainable investing mandate</div>"
        data-html
        data-place='right'
        data-for='sri-logo-for-manager-name'
      >
        <span styleName='sri-logo-for-manager-name-icn'>
          <LinkIcon nospace faclass='fa-leaf'/>
        </span>
        Sustainable fund manager
        <ReactTooltip id='sri-logo-for-manager-name'/>
      </div>
    )
  }
}


/**
 * <FamilyResults
 *   fundFamily
 * />
 *
 * Displays results for major fund families. Includes a chart, category
 * breakdowns, tweet button, and stats on ESG and fossil-free funds. Category
 * breakdowns are rendered by <FamilyResultsSectorDetails />.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyResults extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  getChartData = (fam) => {
    // const chartFossil = '#333'
    const chartGray = '#D5D5D5'
    return [
      {
        value: fam.wff_mil_asset_sum,
        label: 'Military contractors: '+format.perc(fam.wff_mil_weight_total),
        color: '#333'
      },
      {
        value: fam.equity_fund_net_assets - fam.wff_mil_asset_sum,
        label: 'All other holdings',
        color: chartGray
      }
    ]
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }
    // const dsc = format.militaryGradeDescription(
    //   fundFamily.grade_military_fam, true)
    return (
      <div styleName='family-results-wrap'>
        <Row>
          <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>
            <Chart
              currency='US Dollar'
              invested={convert.int(fundFamily.wff_mil_asset_sum)}
              chartMessage='Military weapons'
              chartData={this.getChartData(fundFamily)}
            />
          </Col>
          <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
            <div styleName='sector-details-info-label-energy'>
              <strong>Military weapons</strong>
            </div>
            <FamilyResultsSectorDetails
              type='mmc'
              label='Military contractors'
              sublabel='Largest international arms manufacturers and military contractors'
              count={fundFamily.mmc_count_sum}
              weight={fundFamily.mmc_weight_total}
              asset={fundFamily.mmc_asset_sum}
              currency='US Dollar'
            />
            <FamilyResultsSectorDetails
              type='nw'
              label='Nuclear weapons'
              sublabel='Manufacturers/servicers of nuclear armaments and delivery systems'
              count={fundFamily.nw_count_sum}
              weight={fundFamily.nw_weight_total}
              asset={fundFamily.nw_asset_sum}
              currency='US Dollar'
            />
            <FamilyResultsSectorDetails
              type='cm'
              label='Controversial weapons'
              sublabel='Manufacturers involved with cluster munitions, landmines, white phosphorus, depleted uranium'
              count={fundFamily.cm_count_sum}
              weight={fundFamily.cm_weight_total}
              asset={fundFamily.cm_asset_sum}
              currency='US Dollar'
            />
          </Col>
        </Row>
        <div styleName='chart-content-hl-wrap'>
          <p>
            <LinkIcon faclass='fa-info-circle' nospace />&nbsp;
            These results
            show the combined exposure of
            the fund manager's open-end mutual funds
            and exchange-traded funds
            domiciled in the U.S.
            with at least 50% of assets directly invested in stocks.
            It excludes bond funds,
            target date funds,
            and other fund types like
            closed-end funds,
            collective trusts,
            and funds domiciled outside the U.S. <b>This
            fund manager may have additional
            military weapon investments
            in those types of funds.</b> These results ignore any
            short assets or liabilities held by fund portfolios,
            accounting only for long fund holdings.
          </p>
        </div>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class FamilyTweeter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }
  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }
    return (
      <div>
        <div styleName='family-cta'>
          Fund managers are pouring billions into
          military weapons.
          <br/><b>Share to spread the word.</b>
        </div>
        <Tweeter family item={fundFamily} />
      </div>
    )
  }
}


/**
 * <FamilyResultsSectorDetails
 *   type
 *   label
 *   sublabel
 *   count
 *   weight
 *   asset
 *   currency
 * />
 *
 * Displays details for a fossil fuel sector, like Carbon Underground 200.
 * Depending on the sector, displays a different icon. Displays label,
 * sublabel, count, weight, asset provided by props.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyResultsSectorDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: this.props.type || null,
      label: this.props.label || null,
      sublabel: this.props.sublabel || null,
      count: this.props.count || null,
      weight: this.props.weight || null,
      asset: this.props.asset || null,
      currency: this.props.currency || null,
    }
  }

  render() {
    const {
      type,
      label,
      sublabel,
      count,
      weight,
      asset,
      currency
    } = this.state

    // circle icon
    const iconNormal = require( '../../../static/images/icn-'+type+'-black.svg' )
    // circle icon inactive
    const iconClean = require( '../../../static/images/icn-'+type+'-inactive.svg' )
    // clean or dirty?
    const isDirty = (convert.int(count))
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      cleanDirtyStyle = 'detail-sector-'+type+'-active'
      currIcon = iconNormal
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconClean
    }

    return (
      <div styleName='detail-sector-wrapper'>
        <div styleName={cleanDirtyStyle}>
          <div styleName='detail-sector-detail-icon-wrap'>
            <img
              styleName='detail-icon'
              src={currIcon}
              alt={label}
            />
          </div>
          <div styleName={'detail-title-active'}>
            <div>{label}</div>
            {
              sublabel ?
                (
                  <div styleName='detail-sublabel'>{sublabel}</div>
                ) :
                null
            }
          </div>
          {
            isDirty ?
              (
                <div styleName='detail-sector-stat-wrapper'>

                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.number(count)}
                    </div>
                    <div styleName='detail-stat-label'>holdings</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.money(asset, true, currency, true)}
                    </div>
                    <div styleName='detail-stat-label'>invested</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.perc(weight)}
                    </div>
                    <div styleName='detail-stat-label'>of fund assets</div>
                  </div>
                </div>
              ) :
              (
                <div styleName='single-badge-wrap'>
                  <div styleName='single-badge-text'>
                    <div styleName='single-badge-subtitle'>
                      No direct stock holdings
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
    )
  }
}


/**
 * <FamilyBanner
 *   fundFamily
 * />
 *
 * Displays a banner for the fund family that has a different tagline if the
 * family is one of the families with additional data in config, or just
 * a generic fund family.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyBanner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    return (
      <div styleName='banner-wrap'>
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <div styleName='banner-taglines'>
              <div>
                <div styleName='banner-tagline'>
                  {
                    fundFamily ?
                      (
                        <span>Are your retirement funds</span>
                      ) : (
                        <span>Your retirement plan could</span>
                      )
                  }
                </div>
              </div>
              <div>
                <div styleName='banner-tagline'>
                  {
                    fundFamily ?
                      (
                        <span>invested with {fundFamily.fund_family_label}?</span>
                      ) : (
                        <span>be invested in weapon companies</span>
                      )
                  }
                </div>
              </div>
              <div styleName='toolkit'>
                <div styleName='toolkit-info'>
                  Check out our action toolkit and talk to your retirement
                  plan manager
                </div>
                <Link
                  to={config.routes.toolkit}
                  log={analytics.eventToToolkit()}
                  title='Weapon free action toolkit'>
                  <div styleName='toolkit-action'>
                    Action toolkit<LinkIcon />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


/**
 * <FamilySummarySentence
 *   fundFamily
 * />
 *
 * Displays sentence for the fund family that lists the number of funds
 * analyzed and the amount invested in weapon stocks. This sentence is
 * displayed at the top of the list of funds and shareclasses for this family.
 *
 */
// @CSSModules(Styles, {allowMultiple:true})
// class FamilySummarySentence extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       fundFamily: props.fundFamily || null
//     }
//   }

//   render() {
//     const { fundFamily } = this.state
//     if (!fundFamily) { return null }

//     return (
//       <div styleName='summary'>
//         {fundFamily.num_equity_funds} funds
//         with {format.money(fundFamily.wff_mil_asset_sum, true, 'US Dollar')} in
//         military weapon stocks
//       </div>
//     )
//   }
// }


/**
 * <FamilyFundList
 *   fundList
 * />
 *
 * Displays a list of funds for this family. Maps a fundList to a list of
 * FamilyFundListItem components.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundList: props.fundList || null
    }
  }

  componentWillReceiveProps(props) {
    if (props.fundList) {
      this.setState({
        fundList: props.fundList
      })
    }
  }

  render() {
    const { fundList } = this.state
    if (!fundList) { return null }

    return (
      <div styleName='holding-list'>
        {
          fundList.map((fund, idx) => {
            return (
              <FamilyFundListItem
                fund={fund}
                key={'family-fund-list-item-'+idx}
              />
            )
          })
        }
      </div>
    )
  }
}


/**
 * <FamilyFundListItem
 *   fund
 * />
 *
 * Displays a fund in the list of funds for this family. Displays some summary
 * stats. Displays a list of tickers using the FamilyFundListItemTickerLinks
 * component.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundListItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fund: props.fund || null
    }
  }

  render() {
    const { fund } = this.state
    if (!fund) { return null }

    const {
      // fund_id,
      fund_legal_name,
      currency,
      wff_mil_count,
      wff_mil_asset,
      wff_mil_weight,
      grade_military,
      ussif
    } = fund

    const ussifLogo = require( '../../../static/images/ussif-icon.png' )
    //
    return (
      <div styleName='holding'>
        <div styleName='ticker-name-assets'>
          <div styleName='ticker-name'>
            <div styleName='holdings-name'>
              {fund_legal_name}
            </div>
            { ussif > 0 ?
              <div styleName='holdings-name'>
                <span styleName='leaf-icn'>
                  <LinkIcon faclass='fa-leaf' nospace/>
                </span>
                { ussif > 1 ?
                    <img
                      src={ussifLogo}
                      alt='Member of the Forum for Sustainable and Responsible Investing'
                      styleName='usf-icn'
                    /> : null }
              </div> : null }
            <FamilyFundListItemTickerLinks shareclasses={fund.shareclass} />
          </div>
          <div styleName='ticker-assets'>
            <div styleName='ticker-assets-figure'>
              {format.number(wff_mil_count) }
            </div>
            <div styleName='ticker-assets-label'>
              &nbsp;military weapon stocks
            </div>
          </div>
          <div styleName='ticker-assets'>
            <div styleName='ticker-assets-figure'>
              {format.money(wff_mil_asset, true, currency, true) }
            </div>
            <div styleName='ticker-assets-label'>
              &nbsp;invested
            </div>
          </div>
          <div styleName='ticker-assets'>
            <div styleName='ticker-assets-figure'>
              {format.perc(wff_mil_weight) }
            </div>
            <div styleName='ticker-assets-label'>
              &nbsp;of portfolio
            </div>
          </div>
        </div>
        <div styleName='score-wrapper'>
          <Grade grade={grade_military} blocksmall/>
        </div>
      </div>
    )
  }
}


/**
 * <FamilyFundListItemTickerLinks
 *   shareclasses
 * />
 *
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundListItemTickerLinks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareclasses: props.shareclasses || null
    }
  }

  render() {
    const { shareclasses } = this.state
    if (!shareclasses) { return null }

    const tickerUrls = shareclasses.map((e,i)=>{
      const tckr = e.ticker || 'N/A'
      const safeTicker = e.ticker || 'N'
      const url = config.routes.fund + '/' +
        format.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' +
        config.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id

      return {
        ticker: tckr,
        name: e.name,
        url
      }
    })

    if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
      const e = tickerUrls[0]
      return (
        <div styleName='ticker-links'>
            <Link to={e.url} title={e.name}>
              <span styleName='ticker'>See results<LinkIcon/></span>
            </Link>
        </div>
      )
    }

    return (
      <div styleName='ticker-links'>
        {
          tickerUrls.map((e, i)=>{
            return (
              <Link
                key={'holding-link-'+i}
                to={e.url}
                title={e.name}
              >
                { e.ticker === 'N/A' ?
                    <span styleName='ticker'>{e.name}</span> :
                    <span styleName='ticker'>{e.ticker}</span>
                }
              </Link>
            )
          })
        }
      </div>
    )
  }
}


@connect(
  state => ({
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error,
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple:true})
export default class FundManager extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      family: props.params.fundManagerName || '',
      searchQuery: '',
      lastResult: null,
      funds: [],
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.familyShareClasses(this.state.family, 1)
  }

  componentWillReceiveProps(props) {
    const q = props.params.fundManagerName || ''
    if (q !== this.state.family) {
      this.familyShareClasses(q, 1)
      window.scroll(0, 0)
      this.setState({
        page: 1,
        family: q,
        searchQuery: '',
        lastResult: null,
        funds: [],
      })
    } else if (props.result && this.state.lastResult !== props.result) {
      this.setState({
        lastResult: props.result,
        funds: this.state.funds.concat(props.result)
      })
    }
  }

  getMoreFunds = () => {
    this.familyShareClasses(this.state.family, this.state.page+1)
  }

  familyShareClasses = (family, page) => {
    page = page || this.state.page
    this.setState({page:page})
    this.props.familyShareClasses(family, page)
  }

  configFundFamily = () => {
    return config.familyFunds.find( (family) => family.fund_family_name === this.state.family )
  }

  render() {
    if (!(this.state.page !== 1 || !this.props.searching)) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const fundFamily = this.configFundFamily()
    //
    const noFundManagerNameQuery = !this.props.params.fundManagerName
    const noFamilyConfigFound = (!fundFamily || typeof fundFamily === 'undefined')
    const noResultsFound = (
        this.props.result &&
        this.props.result.length === 0 &&
        this.state.funds.length === 0
      )
    if (noFundManagerNameQuery || noFamilyConfigFound || noResultsFound) {
      this.context.router.push(config.routes.fundManagers)
      return <div styleName='main'>
        <Loader
          options={{scale: 0.70, top:'2.0rem'}}
          loaded={ false }
        />
      </div>
    }

    const { funds } = this.state
    const fundFamilyName = fundFamily.label

    const hasMore = (
      this.state.lastResult &&
      this.state.lastResult.length === config.queryMaxFunds
    )

    const hasUssif = fundFamily.num_e_usf > 0
    // const isSri = fundFamily.equity_fund_sri_long_assets / fundFamily.equity_fund_long_assets > 0.5
    const isSri = fundFamily.sustainable_manager

    const fundManagerTopStatsStat = (e, i) => {
      return <div
        styleName='fund-manager-top-stats-stat-wrap'
        key={'fund-manager-top-stats-stat-wrap-'+i}
      >
        <div>
          <b>{e[0]}</b>
        </div>
        <div>
          {e[1]}
        </div>
      </div>
    }

    //
    return (
      <div styleName='main'>
        {container.helmet(this.state.family)}

        <Loader
          options={{scale: 0.70, top: '2.0rem'}}
          loaded={ this.state.page !== 1 || !this.props.searching}
        />

        { /*
        <div styleName='name-wrap-background'>
          <ContainerDivs>
            <div styleName='back-to-all-fund-managers-link-wrap'>
              <Link to={config.routes.fundManagers} title='All fund managers'>
                <span styleName='back-to-all-fund-managers-link'>
                  <LinkIcon nospace faclass='fa-long-arrow-left'/>
                </span>
                  &nbsp;
                <span styleName='back-to-all-fund-managers-link'>
                  back to all fund managers
                </span>
              </Link>
            </div>
            <h1 styleName='fund-manager-name'>
              {fundFamilyName}
            </h1>
            { hasUssif || isSri ?
                <div styleName='fund-manager-sri-row'>
                  { isSri ? <SriLogo /> : null}
                  { hasUssif ? <UssifLogo /> : null}
                </div> : null
            }
            <div styleName='fund-manager-top-stats-wrap'>
              <div>
                <h2 styleName='fund-manager-top-stats-grade-label'>
                  Military weapons grade
                </h2>
                <div styleName='fund-manager-top-stats-grade-wrap'>
                  <Grade grade={fundFamily.grade_military_fam} large/>
                  <p>
                    {format.militaryGradeDescription(fundFamily.grade_military_fam, true)}
                  </p>
                </div>
                <p styleName='fund-manager-top-stats-grade-methodology-link'>
                  <Link
                    to={config.routes.methodology + '#fund-manager-ratings'}
                    title='Methodology'
                  >
                    <span styleName='white-link'>
                      See how we rate fund managers<LinkIcon/>
                    </span>
                  </Link>
                </p>
              </div>
              <div>
                <h2 styleName='fund-manager-top-stats-grade-label'>
                  &nbsp;
                </h2>
                { [['Funds analyzed',
                    convert.int(fundFamily.num_equity_funds)],
                   ['AUM analyzed',
                    format.money(convert.int(fundFamily.equity_fund_long_assets), 1, 'USD', 1, 1)]].map((e, i) => {
                      return fundManagerTopStatsStat(e, i)
                    })
                }
                <hr />
                { [['Military contractors',
                    format.perc(convert.float(fundFamily.wff_mil_weight_total))],
                   [<span>&nbsp;&nbsp;Nuclear</span>,
                    format.perc(convert.float(fundFamily.nw_weight_total))],
                   [<span>&nbsp;&nbsp;Controversial</span>,
                    format.perc(convert.float(fundFamily.cm_weight_total))]].map((e, i) => {
                      return fundManagerTopStatsStat(e, i)
                    })
                }
              </div>
            </div>
            <div styleName='tweet-wrap'>
              <FamilyTweeter fundFamily={fundFamily}/>
            </div>
          </ContainerDivs>
        </div>

        <ContainerDivs>
          <FamilyResults fundFamily={fundFamily} />
        </ContainerDivs>
        */ }

        <div styleName='holdings-wrapper'>
          <ContainerDivs>
            <h1 styleName='fund-manager-name'>{fundFamilyName}</h1>
            { /* <h2 styleName='fund-table-title'>Funds from this manager</h2> */ }
            { /* <p>We may not have details on every fund included in the stats above.</p> */ }
            <div styleName='holdings-inner'>
              { /* <FamilySummarySentence fundFamily={fundFamily}/> */ }
              <div styleName='rating-label'>
                <div styleName='rating-label-line'/>
                <div styleName='rating-label-info'>
                  Military weapon grade
                </div>
              </div>
              <FamilyFundList fundList={funds} />
            </div>
          </ContainerDivs>
        </div>

        <div styleName='more-funds-wrapper'>
          <Loader
            options={{scale: 0.70, top:'0'}}
            loaded={ !this.props.searching }
          />
          <div styleName='more-funds'>
            <div
              onClick={hasMore ? this.getMoreFunds : null}
              styleName={
                hasMore ? 'more-funds-button' : 'no-more-funds-button'
              }
            >
              {
                hasMore ?
                  'More funds' :
                  'No more funds'
              }<LinkIcon faclass='fa-plus-circle'/>
            </div>
            {
              !hasMore ?
                (
                  <div styleName='no-more-funds-info'>
                    Looking for a fund and can't find it? Sorry,
                    but we don't have everything in our database.
                  </div>
                ) :
                null
            }
          </div>
        </div>

        <FamilyBanner fundFamily={fundFamily}/> :

      </div>
    )
  }
}
